{
	"colorMatchErrorMessage": "There was an error applying color match, please try again.",
	"colorMatchErrorTitle": "Error Applying Color Match",
	"colorMatchImportFailed": "Failed to import color match image: {{detail}}"
}
